import React from "react"
import _ from "lodash"
import PropTypes from "prop-types"

export default function TypeConditionalTextOutcomes({ value, description }) {
  if (!_.isEmpty(value)) {
    let newValue = ""

    newValue =
      "<span class='outcomes-description'><strong>" +
      description +
      "</strong></span><span class='outcomes-value'>" +
      value +
      "</span>"

    return (
      <div
        className="outcomes-values"
        dangerouslySetInnerHTML={{
          __html: newValue,
        }}
      />
    )
  } else {
    return null
  }
}

TypeConditionalTextOutcomes.propTypes = {
  value: PropTypes.string,
  description: PropTypes.string,
}
